import { mockFormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { CLPQuotePersonSummary } from '../../models/clp/clp-quote-person-summary.interface';

export const mockCLPQuotePersonSummary: CLPQuotePersonSummary = {
  fullName: 'Mr. Bob Ross',
  address: mockFormOverrideAddress,
};
